import Vue from 'vue'
import math from '@/util/math'
import { CodeToText } from '@/util/area_tool'

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  duration: 300,
  offset: 0
})

// 数组分类
export function groupBy (array, f) {
  let groups = {}
  array.forEach(function (o) {
    let group = JSON.stringify(f(o))
    groups[group] = groups[group] || []
    groups[group].push(o)
  })
  return Object.keys(groups).map(function (group) {
    return groups[group]
  })
}

// 深度拷贝
export function clone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'clone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = clone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function formatTime (datetime, format) {
  if (!datetime) {
    return '-'
  }
  const time = new Date(datetime)
  if (!time || time.getTime() <= 0) {
    return '-'
  }
  const today = new Date()

  const timeYear = time.getFullYear()
  // const timeMonth = time.getMonth()
  // const timeDay = time.getDate()

  const todayYear = today.getFullYear()
  // const todayMonth = today.getMonth()
  // const todayDay = today.getDate()

  format = format || 'YYYY-MM-DD'
  return Vue.time(time).format(format)

  // if (timeYear == todayYear) {
  //     if (format.indexOf('年') != -1) {
  //         format = format.split('年')[1]
  //     } else if (format.indexOf('-') != -1) {
  //         format = format.split('-').splice(1).join('-')
  //     }
  //     return Vue.time(time).format(format)
  // } else {
  // }
}

export function timePast (datetime) {
  const time = new Date(datetime).getTime()
  if (time <= 0) {
    return '-'
  }

  let now = new Date().getTime() //获取当前时间毫秒
  let diff = (now - time) / 1000 //时间差

  if (diff < 60) {
    return '刚刚'
  } else if (diff >= 60 && diff < 3600) {
    return parseInt(diff / 60) + '分钟前'
  } else if (diff >= 3600 && diff < 3600 * 24) {
    return parseInt(diff / 3600) + '小时前'
  } else if (diff >= 3600 * 24 && diff < 3600 * 24 * 30) {
    return parseInt(diff / (3600 * 24)) + '天前'
  } else if (diff >= 3600 * 24 * 30 && diff < 3600 * 24 * 365) {
    return parseInt(diff / (3600 * 24 * 30)) + '个月前'
  } else {
    return formatTime(datetime)
  }
}

export function timeWait (datetime, diff = 0) {
  let total = diff > 0
  if (!diff) {
    const time = new Date(datetime).getTime()
    if (time <= 0) {
      return '-'
    }

    let now = new Date().getTime() //获取当前时间毫秒
    diff = (now - time) / 1000 //时间差
  }

  var days = parseInt(diff / 86400) // 天  24*60*60*1000
  var hours = parseInt(diff / 3600) - 24 * days // 小时 60*60 总小时数-过去的小时数=现在的小时数
  var minutes = parseInt((diff % 3600) / 60) // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数

  if (diff < 60) {
    minutes = 1
  }

  let str = ''
  if (minutes) {
    str = minutes + '分钟'
  }

  if (hours) {
    str = hours + '小时'
  }

  if (days) {
    str = days + '天'
    if (hours && total) {
      str += hours + '小时'
    }
  }

  return str

  if (diff >= 0 && diff < 3600) {
    return parseInt(Math.ceil(diff / 60)) + '分钟'
  } else if (diff >= 3600 && diff < 3600 * 24) {
    return parseInt(diff / 3600) + '小时'
  } else if (diff >= 3600 * 24 && diff < 3600 * 24 * 30) {
    return parseInt(diff / (3600 * 24)) + '天'
  } else if (diff >= 3600 * 24 * 30 && diff < 3600 * 24 * 365) {
    return parseInt(diff / (3600 * 24 * 30)) + '个月'
  } else {
    return formatTime(datetime)
  }
}

export function numberMul (arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}

  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m).toFixed(2)
  )
}

export function validMobile (str) {
  const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
  return reg.test(str)
}

export function priceIncreasePercent (op, np) {
  np = parseFloat(np)
  const delta = math.subtract(np, op)
  let value = math.toFixed(math.multiply(math.divide(delta, op), 100))
  return (value > 0 ? '+' : '') + value.toFixed(0)
}

export function CustomerAddress (customer) {
  let address = ''
  if (customer.province) {
    address += CodeToText[customer.province] || ''
  }

  if (customer.city) {
    address += CodeToText[customer.city] || ''
  }
  if (customer.county) {
    address += CodeToText[customer.county] || ''
  }
  if (customer.address_detail) {
    address += customer.address_detail
  }
  return address
}

export function isImage (url) {
  var index = url.lastIndexOf('.')
  var ext = url.substr(index + 1)
  return (
    ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(
      ext.toLowerCase()
    ) !== -1
  )
}

export function canPreviewFile (url) {
  var index = url.lastIndexOf('.')
  var ext = url.substr(index + 1)
  return (
    [
      'png',
      'jpg',
      'jpeg',
      'bmp',
      'gif',
      'webp',
      'svg',
      'tiff',
      'pdf',
      '.doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'html',
      'txt',
      'mp4'
    ].indexOf(ext.toLowerCase()) !== -1
  )
}

export function isMobile () {
  let info = navigator.userAgent
  let agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPod',
    'iPad'
  ]
  for (let i = 0; i < agents.length; i++) {
    if (info.indexOf(agents[i]) >= 0) return true
  }
  return false
}

export function messagesFormat (messages) {
  if (!messages || messages.length == 0) {
    return []
  }
  return messages.map(item => {
    item.content = showMessageContent(item)
    if (item.type == 2 || item.type == 3) {
      item.link = '/dashboard/quotations/' + item.event_id
    } else if (item.type == 4 || item.type == 5 || item.type == 6) {
      item.link =
        '/dashboard/dealer/orders/' +
        item.event_id +
        (item.type == 6 ? '?tab=4' : '')
    } else if (item.type == 7) {
      item.link = '/dashboard/notices/detail/' + item.event_id
    } else if (item.type == 15) {
      item.link = '/dashboard/notice_history/' + item.event_id
    } else if (item.type == 16) {
      item.link = '/dashboard/notices/' + item.event_id
    } else if (item.type == 8) {
      item.link = '/dashboard/promotions/promoting'
    } else if (item.type == 1) {
      item.link = '/dashboard/shop/application_orders/' + item.event_id
    } else if (item.type == 9 || item.type == 24) {
      item.link = '/dashboard/shop/approve_orders/' + item.event_id
    } else if (item.type == 10 || item.type == 13 || item.type == 14) {
      item.link = '/dashboard/shop/pending_orders/' + item.event_id
    } else if (item.type == 11) {
      item.link = '/dashboard/shop/invalid_orders/' + item.event_id
    } else if (item.type == 12) {
      item.link = '/dashboard/shop/payed_orders/' + item.event_id
    } else if (item.type == 17) {
      item.link = '/dashboard/shop/done_orders/' + item.event_id
    } else if (
      item.type == 18 ||
      item.type == 19 ||
      item.type == 20 ||
      item.type == 21 ||
      item.type == 22 ||
      item.type == 25 ||
      item.type == 26 ||
      item.type == 27
    ) {
      item.link = '/dashboard/service_quests/list/' + item.event_id
    } else if (item.type == 28) {
      item.link = '/dashboard/repair_service_quests/list/' + item.event_id
    } else if (item.type == 23) {
      item.link = '/dashboard/customers/' + item.event_id
    }
    return item
  })
}

export function showMessageContent (message) {
  let params = message.params
  switch (message.type) {
    case 2:
      return (
        '[报价单] 报价单：' +
        params['number'] +
        '（' +
        params['customer_name'] +
        '）已通过审核'
      )
    case 3:
      return (
        '[报价单] 报价单：' +
        params['number'] +
        '（' +
        params['customer_name'] +
        '）未通过审核'
      )
    case 4:
      return '[报价单] ' + message.content
    case 5:
      return '[报价单] ' + message.content
    case 6:
      return (
        '[订单] 收到订单：' +
        params['number'] +
        '（' +
        params['customer_name'] +
        '）回款￥' +
        params['amount']
      )
    case 7:
    case 15:
    case 16:
      return '[公告] ' + message.content
    case 8:
      return '[促销] ' + message.content
    case 1:
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 14:
    case 17:
    case 24:
      return '[商城] ' + message.content
    case 18:
    case 19:
    case 20:
    case 21:
    case 22:
    case 25:
    case 26:
    case 27:
    case 28:
      return '[服务请求] ' + message.content
    case 23:
      return '[客户设备] ' + message.content
    default:
      break
  }
}

export function showEmptyString (str) {
  if (!str || str.length == 0) {
    return '-'
  }
  return str
}

export function scrollToTop () {
  const el = document.querySelector('body')
  const beginTime = Date.now()
  const beginValue = el.scrollTop
  const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
  const cubic = value => Math.pow(value, 3)
  const easeInOutCubic = value =>
    value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2

  const frameFunc = () => {
    const progress = (Date.now() - beginTime) / 500
    if (progress < 1) {
      el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
      rAF(frameFunc)
    } else {
      el.scrollTop = 0
    }
  }
  rAF(frameFunc)
}

export function filterEncode (filter) {
  return {
    filter: Buffer.from(JSON.stringify(filter), 'utf8').toString('base64')
  }
}

export function filterDecode (filter) {
  return JSON.parse(Buffer.from(filter, 'base64').toString('utf8'))
}

export function stringToBase64 (str) {
  str = encodeURIComponent(str)
  str = str.replaceAll('%', ':')
  str = str.replaceAll('--', 'dbdash')
  str = str.replaceAll('from', '-morf-')
  str = str.replaceAll('(', '-leftbracket-')
  return str
  // return Buffer.from(str, 'utf8').toString('base64')
}

// 客户分类
// '1': '一般经销商',
// '2': '授权代理商',
// '3': 'OEM商',
// "6": '最终用户',
// "7": '其他',
export function isDealerCustomer (category = 0) {
  return [1, 2, 3].includes(category)
}

export default {
  install (Vue, options) {
    Vue.prototype.clone = clone
    Vue.prototype.groupBy = groupBy
    Vue.prototype.filterEncode = filterEncode
    Vue.prototype.filterDecode = filterDecode
    Vue.prototype.isDealerCustomer = isDealerCustomer
  }
}
